import { IconButton } from "@material-ui/core";
import SelectBox from "../common/CustomSelectBox"
import TagBox from "../common/CustomTagBox"
import deleteIcon from "../../images/delete.svg"
import { ADMIN, SUPERADMIN, FINANCIAL_ADMIN } from "../../Constantes/userRoles";
import { useRef } from "react";

function RoleInput(props){

    const {data, usedRoles, roles, services, handleChangeValue, index, handleDeleteRole, userLevel} = props;

    const usedServiceIds = usedRoles.filter(usedRole => usedRole.serviceIds !== null && usedRole.roleId !== data.roleId).map(usedRole=> usedRole.serviceIds).flat();
    const avaliableServices = services.filter(service=> !usedServiceIds.some(usSer=> usSer === service.serviceId));
    const visibleRoles = roles.map(role=> ({...role, visible: !usedRoles.some(selectedRole => selectedRole.roleId === role.roleId && selectedRole.roleId !== data.roleId) && role.level <= userLevel }))
    const selectedAdmin = roles.some(role=> role.roleId === data.roleId && (role.roleName === SUPERADMIN || role.roleName === ADMIN || role.roleName === FINANCIAL_ADMIN))
    const tagboxRef = useRef()

    function handleChangeRole(newRole){
        let updatedValue = {...data, roleId: newRole}
        const isSuperAdmin = roles.some(role=> role.roleId === newRole && (role.roleName === SUPERADMIN || role.roleName === ADMIN || role.roleName === FINANCIAL_ADMIN))
        if(isSuperAdmin){
            updatedValue = {...updatedValue, serviceIds: []}
            tagboxRef.current?.instance?.reset()
        }
            
        handleChangeValue(updatedValue)
    }

    function handleChangeServices(newServices){
        const updatedValue = {...data, serviceIds: newServices}
        handleChangeValue(updatedValue)
    }

    return(
        <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr) 2rem", columnGap: "0.5rem"}}>
            <SelectBox
                disabled={data.level > userLevel}
                dataSource={visibleRoles}
                label={"Rol"}
                value={data.roleId}
                displayExpr={ "roleDescription" }
                valueExpr={"roleId"}
                onValueChanged = { (e) => handleChangeRole(e.value) }
                showClearButton= {false}
            >
            </SelectBox>
            <TagBox
                dataSource={avaliableServices}
                disabled={data.level > userLevel || selectedAdmin}
                showClearButton = { true }
                label={"Serviços"}
                defaultValue = {data.serviceIds|| null}
                displayExpr = { "serviceName" }
                valueExpr={"serviceId"}
                innerRef={tagboxRef}
                onValueChanged =  {(e)=>{handleChangeServices(e.value)}}
                searchEnabled = { true }
            />
            {index > 0 ? <IconButton onClick={()=>handleDeleteRole(data.externalId)} disabled={data.level > userLevel} size="small"><img height={30} src={deleteIcon}/></IconButton> : null}
        </div>
    )
}

export {RoleInput}